import { Injectable, signal } from '@angular/core';
import { catchError, of, take } from 'rxjs';
import { AppAuthService } from '@services/core/auth/app-auth.service';
import { AuthService } from './auth.service';
import {
  ImpersonationApiService,
  ImpersonationState,
  ImpersonationTokenResponse
} from './impersonation-api.service';

@Injectable({ providedIn: 'root' })
export class ImpersonationStateService {
  readonly state$ = signal<ImpersonationState>({ active: false });
  readonly loading$ = signal(false);

  constructor(
    private readonly api: ImpersonationApiService,
    private readonly auth: AuthService,
    private readonly appAuth: AppAuthService,
  ) {}

  syncState(): void {
    this.api.state()
      .pipe(
        take(1),
        catchError(() => of({ active: false })),
      )
      .subscribe(state => this.state$.set(state));
  }

  start(targetIdentityUserId: string): void {
    this.loading$.set(true);
    this.api.start(targetIdentityUserId).pipe(take(1)).subscribe({
      next: res => this.applyAndReload(res),
      error: _ => this.loading$.set(false),
    });
  }

  stop(): void {
    this.loading$.set(true);
    this.api.stop().pipe(take(1)).subscribe({
      next: res => this.applyAndReload(res),
      error: _ => this.loading$.set(false),
    });
  }

  private applyAndReload(res: ImpersonationTokenResponse): void {
    this.auth.replaceToken({
      accessToken: res.accessToken,
      refreshToken: res.refreshToken,
      expires: res.expires,
    });
    this.state$.set(res.impersonation ?? { active: false });
    this.appAuth.refreshUserPractitionerData();
    this.loading$.set(false);
    window.location.reload();
  }
}

